import { NotaryStatus } from '@/modules/notary/enums/NotaryStatus';
import { NotaryStatusKey } from '@/modules/notary/constants/NotaryStatusKey';
import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class WorkflowNotaryStatusTrigger extends BaseEntityModel {
  id?: number;

  status?: string;

  constructor(model: Partial<WorkflowNotaryStatusTrigger> = {}) {
    super(model);

    this.id = model.id;
    this.status = model.status;
  }

  get statusText(): string {
    return NotaryStatus.getByKey(this.status as NotaryStatusKey)?.value ?? '';
  }

  get statusColor(): string {
    return NotaryStatus.getByKey(this.status as NotaryStatusKey)?.color ?? '';
  }
}
